export default {
  'employee.status.activated': 'Active',
  'employee.status.deactivated': 'Pending',

  'device.status.online': 'Online',
  'device.status.offline': 'Offline',
  'device.status.active': 'Active',
  'device.status.deactive': 'Inactive',
};
